import {
  PersonIcon,
  ExitIcon,
  ProfileReservation,
  EarnPoints,
  AccountSettings,
  FavoriteDeleteIcon,
  RegisteredUserIcon,
} from '@assets/icons';
import { HotelRoomStatusType } from '@api/index';

export const Currencies = {
  TL: 'TL',
  EUR: 'EUR',
  USD: 'USD',
  GBP: 'GBP',
};

export const LOYALTY_TYPES = {
  HOPI: 'HOPI',
  TURK_TELEKOM: 'TURK_TELEKOM',
};
export const RE_DIGIT = new RegExp(/^\d+$/);
export const TURKEY_COUNTRY_CODE = 'TR';
export const TURKEY_COUNTRY_PHONE_CODE = '+90';

export const USER_MENU_ITEMS = [
  {
    icon: PersonIcon,
    name: 'Profilim',
    href: '/profil',
    feature: 'profile',
  },
  {
    name: 'Rezervasyonlarım',
    href: '/profil/rezervasyonlarim',
    icon: ProfileReservation,
    feature: 'reservation',
  },
  {
    icon: ExitIcon,
    name: 'Çıkış Yap',
    href: '/logout',
  },
];

export const SIDE_MENU_ITEMS = [
  {
    label: 'Profilim',
    link: '/profil',
    icon: 'profile',
    feature: 'profile',
    iconComponent: PersonIcon,
  },
  {
    label: 'Rezervasyonlarım',
    link: '/profil/rezervasyonlarim',
    icon: 'calender',
    feature: 'reservation',
    iconComponent: ProfileReservation,
  },
  {
    label: 'Favorilerim',
    link: '/profil/favorilerim',
    icon: 'favorite',
    feature: 'favorites',
    iconComponent: FavoriteDeleteIcon,
  },
  {
    label: 'Kayıtlı Kişilerim',
    link: '/profil/kayitli-kisilerim',
    icon: 'registeredUser',
    feature: 'register',
    iconComponent: RegisteredUserIcon,
  },

  {
    label: 'Setur Extra',
    link: '/profil/puanlarim',
    icon: 'setur',
    feature: 'loyalty',
    subItems: [
      { label: 'Setur Puanlarım', link: '/profil/puanlarim' },
      { label: 'Kulüplerim', link: '/profil/indirim-kulupleri' },
      { label: 'Kuponlarım', link: '/profil/kuponlarim' },
      { label: 'Referans', link: '/profil/referans' },
      { label: 'Sözleşme ve Koşullar', link: '/profil/sozlesme' },
    ],
    iconComponent: EarnPoints,
  },
  {
    label: 'Hesap Ayarları',
    link: '/profil/hesap-ayarlari',
    icon: 'account-settings',
    feature: 'loyalty',
    iconComponent: AccountSettings,
  },
  {
    label: 'Çıkış Yap',
    link: '/logout',
    icon: 'logout',
    feature: 'logout',
    iconComponent: ExitIcon,
  },
];

export type SideMenuItemElement = (typeof SIDE_MENU_ITEMS)[number];

export const KVKK_AGREEMENT =
  '<br/><br/>SİTE KULLANIM ŞARTLARI <br/>Lütfen sitemizi kullanmadan evvel bu ‘site kullanım şartları’nı dikkatlice okuyunuz.<br/>Bu alışveriş sitesini kullanan ve alışveriş yapan müşterilerimiz aşağıdaki şartları kabul etmiş varsayılmaktadır:<br/>Sitemizdeki web sayfaları ve ona bağlı tüm sayfalar (‘site’) https://www.setur.com.tr adresindeki Setur Servis Turistik A.Ş. firmasının (Firma) malıdır ve onun tarafından işletilir. Sizler (‘Kullanıcı’) sitede sunulan tüm hizmetleri kullanırken aşağıdaki şartlara tabi olduğunuzu, sitedeki hizmetten yararlanmakla ve kullanmaya devam etmekle; Bağlı<br/>olduğunuz yasalara göre sözleşme imzalama hakkına, yetkisine ve hukuki ehliyetine sahip ve 18 yaşın üzerinde olduğunuzu, bu sözleşmeyi okuduğunuzu, anladığınızı ve sözleşmede yazan şartlarla bağlı olduğunuzu kabul etmiş sayılırsınız.<br/>İşbu sözleşme taraflara sözleşme konusu site ile ilgili hak ve yükümlülükler yükler ve taraflar işbu sözleşmeyi kabul ettiklerinde bahsi geçen hak ve yükümlülükleri eksiksiz, doğru, zamanında, işbu sözleşmede talep edilen şartlar dâhilinde yerine getireceklerini beyan ederler.';

export const MEMBERSHIP_AGREEMENT =
  '<br/><br/>SİTE KULLANIM ŞARTLARI<br/>Lütfen sitemizi kullanmadan evvel bu ‘site kullanım şartları’nı dikkatlice okuyunuz.<br/>Bu alışveriş sitesini kullanan ve alışveriş yapan müşterilerimiz aşağıdaki şartları kabul etmiş varsayılmaktadır:<br/>Sitemizdeki web sayfaları ve ona bağlı tüm sayfalar (‘site’) https://www.setur.com.tr adresindeki Setur Servis Turistik A.Ş. firmasının (Firma) malıdır ve onun tarafından işletilir. Sizler (‘Kullanıcı’) sitede sunulan tüm hizmetleri kullanırken aşağıdaki şartlara tabi olduğunuzu, sitedeki hizmetten yararlanmakla ve kullanmaya devam etmekle; Bağlı<br/>olduğunuz yasalara göre sözleşme imzalama hakkına, yetkisine ve hukuki ehliyetine sahip ve 18 yaşın üzerinde olduğunuzu, bu sözleşmeyi okuduğunuzu, anladığınızı ve sözleşmede yazan şartlarla bağlı olduğunuzu kabul etmiş sayılırsınız.<br/>İşbu sözleşme taraflara sözleşme konusu site ile ilgili hak ve yükümlülükler yükler ve taraflar işbu sözleşmeyi kabul ettiklerinde bahsi geçen hak ve yükümlülükleri eksiksiz, doğru, zamanında, işbu sözleşmede talep edilen şartlar dâhilinde yerine getireceklerini beyan ederler.';

export const SORT_DATA = [
  {
    id: 'popularity',
    label: 'Popüler',
    disabled: false,
    name: 'popularity',
  },

  {
    id: 'priceasc',
    label: 'Fiyata Göre (Artan)',
    disabled: false,
    name: 'priceasc',
  },

  {
    id: 'pricedesc',
    label: 'Fiyata Göre (Azalan)',
    disabled: false,
    name: 'pricedesc',
  },

  {
    id: 'dateasc',
    label: 'Tarih (Yakın)',
    disabled: false,
    name: 'dateasc',
  },

  {
    id: 'datedesc',
    label: 'Tarih (Uzak)',
    disabled: false,
    name: 'datedesc',
  },
];

export const HOTEL_SORT_DATA = [
  {
    id: 'popularity',
    label: 'Popüler',
    disabled: false,
    name: 'popularity',
  },

  {
    id: 'priceasc',
    label: 'Fiyata Göre (Artan)',
    disabled: false,
    name: 'priceasc',
  },

  {
    id: 'pricedesc',
    label: 'Fiyata Göre (Azalan)',
    disabled: false,
    name: 'pricedesc',
  },

  {
    id: 'rateasc',
    label: ' İndirim (Artan)',
    disabled: false,
    name: 'rateasc',
  },

  {
    id: 'ratedesc',
    label: 'İndirim (Azalan)',
    disabled: false,
    name: 'ratedesc',
  },
  {
    id: 'PointDesc',
    label: 'Puana Göre',
    disabled: false,
    name: 'pointdesc',
  },
];

export const HOTEL_SORT_DATA_EXPEDİA = [
  {
    id: 'popularity',
    label: 'Popüler',
    disabled: false,
    name: 'popularity',
  },

  {
    id: 'priceasc',
    label: 'Fiyata Göre (Artan)',
    disabled: false,
    name: 'priceasc',
  },

  {
    id: 'pricedesc',
    label: 'Fiyata Göre (Azalan)',
    disabled: false,
    name: 'pricedesc',
  },

  {
    id: 'rateasc',
    label: ' İndirim (Artan)',
    disabled: false,
    name: 'rateasc',
  },

  {
    id: 'ratedesc',
    label: 'İndirim (Azalan)',
    disabled: false,
    name: 'ratedesc',
  },
];

export const HOTEL_PAST_SEARCH = 'hotelPastSearch';
export const PACKAGE_PAST_SEARCH = 'packagePastSearch';
export const TOUR_PAST_SEARCH = 'tourPastSearch';
export const CRUISE_PAST_SEARCH = 'cruisePastSearch';
export const TR_WEEK_DAY_NAMES = [
  'Pazar',
  'Pazartesi',
  'Salı',
  'Çarşamba',
  'Perşembe',
  'Cuma',
  'Cumartesi',
];

export const TURKEY_ID = '218';

export const BASKET_LOCKED_MESSAGE = 'Basket Kilitli.';

export enum ServiceTypes {
  HOTEL = 'HOTEL',
  TOUR = 'TOUR',
  FLIGHT = 'FLIGHT',
}
export const SKELETON_ITEMS_PLACEHOLDER = [1, 2, 3, 4, 5, 6, 7, 8];

export const advancePaymentStorageKey = 'advancePaymentStatus'; //local storage item name for Advance Payment Status
export const activePaymentMethodStorageKey = 'activePaymentMethod';
export const AdvancePaymentStatus = {
  ON_GOING: 'ON_GOING',
  SUCCESS: 'SUCCESS',
  PAY_REMAINING_NOW: 'PAY_REMAINING_NOW',
};

export const INVISIBLE_CHATBOT_PAGES = [
  '/seyahat-planlama',
  '/rezervasyon-bilgileri',
  'Hotel',
  'Tour',
  '/ic-hat-ucuslari',
  '/dis-hat-ucuslari',
];

export const EXTRA_SERVICE_TYPES = {
  CANCELLATION_GUARANTEE: 11,
  ACTIVITY: 5,
  BUSINESS_CLASS_AIRPLANE: 2,
  GOLF_ACTIVITY: 8,
};

export const FILTERS_QUERY_PARAMS = [
  'priceMin',
  'priceMax',
  'refundable',
  'keywords',
  'status',
  'region',
  'theme',
  'boardType',
  'date',
  'feature',
  'popularity',
  'star',
  'point',
  'segment',
  'transportation',
  'specialPeriod',
  'visa',
  'category',
  'departure',
];

export const SeturPointsTableHeaders = [
  'İşlem Tarihi',
  'Puan/Kupon Miktarı',
  'Puan/Kupon Tipi',
  'İşlem Tipi',
  'İşlem Kanalı',
];

export const DATES_STATUS_TYPES = [
  {
    type: HotelRoomStatusType.OPEN_SALE,
    label: 'Müsait',
  },
  {
    type: HotelRoomStatusType.ASK_SELL,
    label: 'Kontenjan Sor',
  },

  {
    type: HotelRoomStatusType.CLOSE_SALE,
    label: 'Müsaitlik Yok',
  },
];

export const HOTEL_SEARCH_TYPES = {
  HOTEL_LISTING: 'HotelListing',
  HOTEL_DETAIL: 'HotelDetail',
};

export const FLIGHT_SORT_DATA = [
  {
    id: 'lowest-price',
    label: 'Fiyata Göre Artan',
    disabled: false,
    name: 'lowest-price',
  },

  {
    id: 'shortest-time',
    label: 'En Kısa Süre',
    disabled: false,
    name: 'shortest-time',
  },

  {
    id: 'departure-time',
    label: 'En Erken Kalkış Saati',
    disabled: false,
    name: 'departure-time',
  },

  {
    id: 'arrival-time',
    label: 'En Erken Varış Saati',
    disabled: false,
    name: 'arrival-time',
  },
];
export const NOİNDEX_DYNAMİC_PAGES = [
  'tourList',
  'tourDetail',
  'hotelList',
  'hotelDetail',
  'campaignDetail',
  'flightCityLanding',
  'static',
  'paymentOptions',
  'campaigns',
  'packageDetail',
];

export const NOİNDEX_STATİC_PAGES = [
  '/',
  '/ucus-durumu-goruntuleme',
  '/ucak-e-bilet',
  '/ucak-bileti',
  '/seyahat-planlama',
  '/arac-kiralama',
  '/giris-yap',
  '/online-check-in',
  '/kampanyalar',
];

export const SSO_AUTH_REDIRECT_KEYS = {
  LOGOUT: 'ssoLogoutRedirectURL',
  LOGIN: 'ssoLoginRedirectURL',
};

export const SSO_MAIL_KEY = 'ssoMail';
export const SSO_USER_DATA = 'ssoUserData';
export const SECRET_KEY = 'secret';
export const AFFILIATION_KEY = 'affiliation';
export const TRIVAGO_KEY = 'trivago';
export const SETUR_LOCAL_HOTEL = 'SeturLocalHotel';
export const MIN_HOTEL_PRICE_DISCOUNT = 5000;
export const INSIDER_CONFIRMATION_KEY = 'insider_confirmation';

export const DYNAMIC_HOTEL_IMAGE_SIZE_LABEL = '{size}';

export const OTP_EXPIRATION_TIME = 3;

export const ABROAD_TOUR_TYPE = 'Abroad';

export const APP_URL_SCHEME = 'setur://';

export const MAX_SETUR_POINTS_EARN = 4000;

export const validNoindexQueryParams = [
  'in',
  'out',
  'room',
  'priceMin',
  'priceMax',
  'date',
  'status',
  'keywords',
  'theme',
  'feature',
  'region',
  'sort',
  'bid',
  'point',
  'popularity',
  'IsOneWay',
  'bid',
  'redirectUrl',
];

export const PURCHASE_DATA_LAYER_KEY = 'PURCHASE_DATA_LAYER';
